import React, { useCallback, useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import "../../assets/styles/pages/Usuarios.scss";
import "pure-css-loader/src/loader-default.sass";
import business from "../../services/business.js";
import Layout from "../../components/Layout.js";
import InputForm from "../../components/Form/InputForm.js";

export default function Logs() {

    document.title = "säästo";

    const [listagem, setListagem] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);
    const [pager, setPager] = useState({
        page: 1,
        total_pages: 0,
        total_rows: 0,
    });
    const [filtros, setFiltros] = useState({
        id_processo: "",
    });

    const setFiltro = (name, value) => {
        setFiltros((old) => ({
            ...old,
            [name]: value,
        }));
    };

    const getSearch = useCallback(async (page = 1, filtrosBusca = { id_processo: "" }, showLoader = true) => {
        if (showLoader) {
            setLoading(true);
        } else {
            setSearchLoading(true);
        }

        let logs = await business.getLogs(
            page,
            10,
            "",
            "",
            filtrosBusca?.id_processo || ""
        );

        setListagem(logs?.response || []);

        setPager({
            page: logs?.pager?.pagina || 1,
            total_pages: logs?.pager?.paginas || 0,
            total_rows: logs?.pager?.total || 0,
        });

        setLoading(false);
        setSearchLoading(false);
    }, []);

    useEffect(() => {
        getSearch();
    }, [getSearch]);

    const aplicarFiltros = async () => {
        await getSearch(1, filtros, false);
    };

    const limparFiltros = async () => {
        const filtrosLimpos = {
            id_processo: "",
        };

        setFiltros(filtrosLimpos);
        await getSearch(1, filtrosLimpos, false);
    };

    const handlePageClick = (e) => {
        getSearch(e.selected + 1, filtros, false);
    };

    return (
        <Layout className="view-listagem">
            <p className="page-title">
                Administração / <span className="blue-text">Logs de Sistema</span>
            </p>
            <h2 className="title flex jc-sb ai-fe black-text mb-40 gap-10">
                Logs de Sistema
            </h2>

            <div className="mb-40">
                <div className="flex gap-20 ai-ge" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(240px, 320px))" }}>
                    <InputForm
                        label="Processo"
                        type="number"
                        name="id_processo"
                        placeholder="ID do processo"
                        value={filtros.id_processo}
                        model={setFiltro}
                        onKeyPress={(e) => {
                            if (e.key === "Enter") {
                                aplicarFiltros();
                            }
                        }}
                    />
                    <button className="btn btn-primary f700-16" onClick={aplicarFiltros} disabled={searchLoading}>
                        Filtrar
                    </button>
                    <button className="btn btn-outline-primary f700-16" onClick={limparFiltros} disabled={searchLoading}>
                        Limpar
                    </button>
                </div>
            </div>

            {(loading || searchLoading) ? (
                <div className="loader loader-default is-active" />
            ) : (
                <div>
                    <div className="table-mobile">
                        {listagem.map((p, i) => {
                            return (
                                <div className="item pointer" key={`mobile-${i}`}>
                                    <div>
                                        <div className="fn-16 linha flex jc-sb">
                                            Data
                                            <span>{p.data_cadastro}</span>
                                        </div>
                                        <div className="fn-16 linha flex jc-sb">
                                            Usuário
                                            <span>{p.nome_usuario + "(" + p.id_usuario + ")"}</span>
                                        </div>
                                        <div className="fn-16 linha flex jc-sb">
                                            Processo
                                            <span>{p.id_processo || "-"}</span>
                                        </div>
                                        <div className="fn-16 linha flex jc-sb">
                                            Descrição
                                            <span>{p.descricao}</span>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                        {(!listagem || !listagem?.length) && (
                            <div className="item pointer" key="mobile-0">
                                Nenhum resultado encontrado.
                            </div>
                        )}
                    </div>
                    <table className="w-100 table-desktop">
                        <thead className="f300-16">
                            <tr>
                                <th className="text-left bold">Data</th>
                                <th className="text-left bold">Usuário</th>
                                <th className="text-left bold">Processo</th>
                                <th className="text-left bold">Descrição</th>
                            </tr>
                        </thead>
                        <tbody>
                            {listagem.map((p, i) => {
                                return (
                                    <tr key={`desktop-${i}`}>
                                        <td className="fn-16">{p.data_cadastro}</td>
                                        <td className="fn-16">{p.nome_usuario + "(" + p.id_usuario + ")"}</td>
                                        <td className="fn-16">{p.id_processo || "-"}</td>
                                        <td className="fn-16">{p.descricao}</td>
                                    </tr>
                                );
                            })}
                            {(!listagem || !listagem?.length) && (
                                <tr>
                                    <td colSpan={4}>Nenhum resultado encontrado.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    <div className="component pagination">
                        <div className="pagination-container mt-30">
                            {pager.total_pages < 2 ? (
                                ""
                            ) : (
                                <ReactPaginate
                                    previousLabel="«"
                                    nextLabel="»"
                                    breakLabel="..."
                                    breakClassName="break-me"
                                    page={pager.page - 1 ?? 0}
                                    forcePage={pager.page - 1 ?? 0}
                                    pageCount={pager.total_pages}
                                    marginPagesDisplayed={3}
                                    pageRangeDisplayed={5}
                                    onPageChange={handlePageClick}
                                    containerClassName="pagination"
                                    subContainerClassName="pages pagination"
                                    activeClassName="active"
                                />
                            )}
                        </div>
                    </div>
                </div>
            )}
        </Layout>
    );
}
